import { put, takeLeading, throttle } from 'redux-saga/effects';
import { push } from 'connected-react-router';

import HospitalAPI from 'lib/api/HospitalAPI';
import createRequestSaga from 'store/helpers/createRequestSaga';
import { openSnackbar } from 'features/snackbar';
import {
  ASSIGN_FORMSET,
  CREATE_FORMSET,
  GET_SUMMARIZE_FORMSET_LIST,
  GET_FORMSET_DETAIL,
  GET_ASSIGN_FORMSET_LIST,
  UPDATE_FORMSET,
  DELETE_FORMSET,
  GET_ASSIGN_FORMSET_DETAIL,
  NOTIFY_ASSIGN,
  CREATE_SUBMITTED_FORMSET,
  GET_FORMSET_COLLECTION_LIST,
  CREATE_FORMSET_COLLECTION,
  UPDATE_FORMSET_COLLECTION,
  DELETE_FORMSET_COLLECTION,
  GET_PROTOCOL_LIST,
  GET_PROTOCOL_DETAIL,
  CREATE_PROTOCOL,
  DELETE_PROTOCOL,
  ASSIGN_PROTOCOL,
  UPDATE_ASSIGNED_PROTOCOL,
  DELETE_ASSIGNED_PROTOCOL,
  UPDATE_QUESTION,
  UPDATE_STANDARD,
  UPDATE_SUBMITTED_FORMSET,
} from '.';

const getSummarizeFormsetListSaga = createRequestSaga(
  GET_SUMMARIZE_FORMSET_LIST,
  HospitalAPI.getSummarizeFormsetList,
);
const getFormsetDetailSaga = createRequestSaga(
  GET_FORMSET_DETAIL,
  HospitalAPI.getFormsetDetail,
);
const getAssignFormsetListSaga = createRequestSaga(
  GET_ASSIGN_FORMSET_LIST,
  HospitalAPI.getAssignFormsetList,
);
const getAssignFormsetDetailSaga = createRequestSaga(
  GET_ASSIGN_FORMSET_DETAIL,
  HospitalAPI.getAssignFormsetDetail,
);
const assignFormsetSaga = createRequestSaga(
  ASSIGN_FORMSET,
  HospitalAPI.assignFormset,
  function* () {
    yield put(openSnackbar('척도검사가 발송되었습니다'));
  },
);
const createFormsetSaga = createRequestSaga(
  CREATE_FORMSET,
  HospitalAPI.createFormset,
  function* () {
    yield put(openSnackbar('검사지가 만들어졌습니다'));
  },
);
const updateFormsetSaga = createRequestSaga(
  UPDATE_FORMSET,
  HospitalAPI.updateFormset,
  function* () {
    yield put(openSnackbar('검사지 정보가 수정되었습니다'));
  },
);
const deleteFormsetSaga = createRequestSaga(
  DELETE_FORMSET,
  HospitalAPI.deleteFormset,
  function* () {
    yield put(openSnackbar('검사지가 삭제되었습니다'));
  },
);
const notifyAssignSaga = createRequestSaga(
  NOTIFY_ASSIGN,
  HospitalAPI.notifyAssign,
  function* () {
    yield put(openSnackbar('검사지 발송 알림이 전송되었습니다'));
  },
);
const createSubmittedFormsetSaga = createRequestSaga(
  CREATE_SUBMITTED_FORMSET,
  HospitalAPI.createSubmittedFormset,
  function* ({ data: { id } }) {
    yield put(openSnackbar('검사지가 제출되었습니다'));
    yield put(push(`/results/${id}`));
  },
);
const getFormsetCollectionListSaga = createRequestSaga(
  GET_FORMSET_COLLECTION_LIST,
  HospitalAPI.getFormsetCollectionList,
);
const createFormsetCollectionSaga = createRequestSaga(
  CREATE_FORMSET_COLLECTION,
  HospitalAPI.createFormsetCollection,
  function* () {
    yield put(openSnackbar('검사지 세트가 만들어졌습니다'));
    yield put(push('/forms'));
  },
);
const updateFormsetCollectionSaga = createRequestSaga(
  UPDATE_FORMSET_COLLECTION,
  HospitalAPI.updateFormsetCollection,
  function* () {
    yield put(openSnackbar('검사지 세트가 수정되었습니다'));
    yield put(push('/forms'));
  },
);
const deleteFormsetCollectionSaga = createRequestSaga(
  DELETE_FORMSET_COLLECTION,
  HospitalAPI.deleteFormsetCollection,
  function* () {
    yield put(openSnackbar('검사지 세트가 삭제되었습니다'));
  },
);
const getProtocolListSaga = createRequestSaga(
  GET_PROTOCOL_LIST,
  HospitalAPI.getProtocolList,
);
const getProtocolDetailSaga = createRequestSaga(
  GET_PROTOCOL_DETAIL,
  HospitalAPI.getProtocolDetail,
);
const createProtocolSaga = createRequestSaga(
  CREATE_PROTOCOL,
  HospitalAPI.createProtocol,
  function* () {
    yield put(push('/forms'));
    yield put(openSnackbar('프로토콜이 생성되었습니다'));
  },
);
const deleteProtocolSaga = createRequestSaga(
  DELETE_PROTOCOL,
  HospitalAPI.deleteProtocol,
  function* () {
    yield put(openSnackbar('프로토콜이 삭제되었습니다'));
  },
);
const assignProtocolSaga = createRequestSaga(
  ASSIGN_PROTOCOL,
  HospitalAPI.assignProtocol,
  function* () {
    yield put(openSnackbar('프로토콜이 지정되었습니다'));
  },
);
const updateAssignedProtocolSaga = createRequestSaga(
  UPDATE_ASSIGNED_PROTOCOL,
  HospitalAPI.updateAssignedProtocol,
  function* () {
    yield put(openSnackbar('프로토콜이 지정되었습니다'));
  },
);
const deleteAssignedProtocolSaga = createRequestSaga(
  DELETE_ASSIGNED_PROTOCOL,
  HospitalAPI.deleteAssignedProtocol,
);
const updateQuestionSaga = createRequestSaga(
  UPDATE_QUESTION,
  HospitalAPI.updateQuestion,
);
const updateStandardSaga = createRequestSaga(
  UPDATE_STANDARD,
  HospitalAPI.updateStandard,
);
const updateSubmittedFormsetSaga = createRequestSaga(
  UPDATE_SUBMITTED_FORMSET,
  HospitalAPI.updateSubmittedFormset,
  function* () {
    yield put(openSnackbar('취소되었습니다'));
  },
);

export default function* formsSaga() {
  yield throttle(1000, GET_SUMMARIZE_FORMSET_LIST, getSummarizeFormsetListSaga);
  yield throttle(1000, GET_ASSIGN_FORMSET_LIST, getAssignFormsetListSaga);
  yield throttle(1000, GET_ASSIGN_FORMSET_DETAIL, getAssignFormsetDetailSaga);
  yield throttle(
    1000,
    GET_FORMSET_COLLECTION_LIST,
    getFormsetCollectionListSaga,
  );
  yield throttle(1000, GET_FORMSET_DETAIL, getFormsetDetailSaga);
  yield throttle(1000, GET_PROTOCOL_LIST, getProtocolListSaga);
  yield throttle(1000, GET_PROTOCOL_DETAIL, getProtocolDetailSaga);
  yield takeLeading(ASSIGN_FORMSET, assignFormsetSaga);
  yield takeLeading(CREATE_FORMSET, createFormsetSaga);
  yield takeLeading(UPDATE_FORMSET, updateFormsetSaga);
  yield takeLeading(DELETE_FORMSET, deleteFormsetSaga);
  yield takeLeading(NOTIFY_ASSIGN, notifyAssignSaga);
  yield takeLeading(CREATE_FORMSET_COLLECTION, createFormsetCollectionSaga);
  yield takeLeading(UPDATE_FORMSET_COLLECTION, updateFormsetCollectionSaga);
  yield takeLeading(DELETE_FORMSET_COLLECTION, deleteFormsetCollectionSaga);
  yield takeLeading(CREATE_SUBMITTED_FORMSET, createSubmittedFormsetSaga);
  yield takeLeading(CREATE_PROTOCOL, createProtocolSaga);
  yield takeLeading(DELETE_PROTOCOL, deleteProtocolSaga);
  yield takeLeading(ASSIGN_PROTOCOL, assignProtocolSaga);
  yield takeLeading(UPDATE_ASSIGNED_PROTOCOL, updateAssignedProtocolSaga);
  yield takeLeading(DELETE_ASSIGNED_PROTOCOL, deleteAssignedProtocolSaga);
  yield takeLeading(UPDATE_QUESTION, updateQuestionSaga);
  yield takeLeading(UPDATE_STANDARD, updateStandardSaga);
  yield takeLeading(UPDATE_SUBMITTED_FORMSET, updateSubmittedFormsetSaga);
}
